import { initProductsCarousel } from './products-carousel';
import initScrollmagic from './scrollmagic';

export default () => {
  if ($('body').attr('class').indexOf('lookbook') === -1) {
    return;
  }

  initProductsCarousel();
  initScrollmagic();
};
